import { apiFetch } from '../../../lib/http';

export const learnerApi = {
  generateSupervisionCode({ auth = true } = {}) {
    return apiFetch('/api/v1/learner/supervision-code', { method: 'POST', auth });
  },

  listSupervisors({ auth = true } = {}) {
    return apiFetch('/api/v1/learner/supervisors', { method: 'GET', auth });
  },

  revokeSupervisor({ supervisorId, auth = true }) {
    return apiFetch(`/api/v1/learner/supervisors/${encodeURIComponent(supervisorId)}`, {
      method: 'DELETE',
      auth,
    });
  },
};
